import { useCallback, useState } from 'react';
import { GridCellModes } from '@mui/x-data-grid-pro';

const useSingleClickEditDataGrid = (stackedRequestsRef) => {
  const [cellModesModel, setCellModesModel] = useState({});

  const handleCellClick = useCallback((params, event) => {
    if (!params.isEditable) {
      return;
    }

    // Ignore portal
    if (!event.currentTarget.contains(event.target)) {
      return;
    }

    // Used to block switch Conventional/Organic when a cell is in edit mode
    if (!stackedRequestsRef?.current.some((req) => req.cellHasEdited === params.id)) {
      stackedRequestsRef?.current.push({
        cellHasEdited: params.id,
      });
    }

    setCellModesModel((prevModel) => {
      return {
        // Revert the mode of the other cells from other rows
        ...Object.keys(prevModel).reduce(
          (acc, id) => ({
            ...acc,
            [id]: Object.keys(prevModel[id]).reduce(
              (acc2, field) => ({
                ...acc2,
                [field]: { mode: GridCellModes.View },
              }),
              {}
            ),
          }),
          {}
        ),
        [params.id]: {
          // Revert the mode of other cells in the same row
          ...Object.keys(prevModel[params.id] || {}).reduce(
            (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
            {}
          ),
          [params.field]: { mode: GridCellModes.Edit },
        },
      };
    });
  }, []);

  const handleCellModesModelChange = useCallback((newModel) => {
    setCellModesModel(newModel);
  }, []);

  return { cellModesModel, handleCellClick, handleCellModesModelChange };
};

export default useSingleClickEditDataGrid;
